const container = document.querySelector('.cookies-popup');
const getStoredCookie = (name) => {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

if (
  getStoredCookie('cookies-popup') === undefined ||
  getStoredCookie('cookies-popup') !== 'closed' ||
  container.dataset.mode === 'testing'
) {

  const isMobile = window.innerWidth <= 768;
  const displayValue = isMobile ? 'flex' : 'block';
  container.style.display = displayValue;

  setTimeout(() => {
    container.classList.add('cookies-popup--animate');
  }, 3000);
}

document.getElementById('cookiesTrigger').addEventListener('click', () => {
  container.classList.remove('cookies-popup--animate');

  setTimeout(() => {
    container.style.display = 'none';
  }, 3000);

  if (container.dataset.mode === 'enabled') {
    document.cookie = `cookies-popup=closed; path=/; max-age=${60 * 60 * 24 * container.dataset.cookies}`;
  }
});
